export const SET_ENTITY = "SET_ENTITY";
export const ADD_ENTITY = "ADD_ENTITY";
export const UPDATE_ENTITY = "UPDATE_ENTITY";
export const DELETE_ENTITY = "DELETE_ENTITY";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
